<template>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <tabs type="boxed">
            <tab-pane label="Параметры рассылки">
              <label class="label">Название</label>
              <p class="control">
                <input v-model="campaign.namePostfix" class="input" type="text" placeholder="Введите название рассылки" :readonly="!canEdit()">
              </p>
              <label class="label">Дата прозвона</label>
              <datepicker :disabled="!canEdit()&&!canContinue()" v-model="campaign.date"  class="date" placeholder="Введите дату" :config="{ wrap: true, dateFormat: 'd.m.Y', locale: l10n }">
                <a class="button" data-toggle  :disabled="!canEdit()&&!canContinue()"><i class="fa fa-calendar"></i></a>
                <a class="button" data-clear  :disabled="!canEdit()&&!canContinue()"><i class="fa fa-close"></i></a>
              </datepicker>
              <label class="label">Часовой пояс (UTC)</label>
              <p class="control">
              <span class="select">
                <select v-model="campaign.zoneOffset" :disabled="!canEdit()">
                  <option>0</option>
                  <option>+1</option>
                  <option>+2</option>
                  <option>+3</option>
                  <option>+4</option>
                  <option>+5</option>
                  <option>+6</option>
                  <option>+7</option>
                  <option>+8</option>
                  <option>+9</option>
                  <option>+10</option>
                  <option>+11</option>
                  <option>+12</option>
                </select>
              </span>
              </p>
              <label class="label">Время прозвона</label>
              <p class="control has-addons">
                <!--С<datepicker  :disabled="!canEdit()&&!canContinue()" v-model="campaign.timeStart" class="time" placeholder="Начало прозвона" :config="{ time_24hr: true, enableTime: true, enableSeconds: false, noCalendar: true }" value="10:00"></datepicker>
                &nbsp;&nbsp;До<datepicker :disabled="!canEdit()&&!canContinue()"  v-model="campaign.timeEnd" class="time" placeholder="Завершение прозвона" :config="{ time_24hr: true, enableTime: true, enableSeconds: false, noCalendar: true }" value="18:00"></datepicker>-->
                С<input v-model="campaign.timeStart" class="time" type="text" pattern="(([0,1][0-9])|(2[0-3])):[0-5][0-9]" placeholder="XX:XX" value="10:00" :readonly="!canEdit()&&!canContinue()" :onblur="transformTimeStart()">
                &nbsp;&nbsp;До<input v-model="campaign.timeEnd" class="time" type="text" pattern="(([0,1][0-9])|(2[0-3])):[0-5][0-9]" placeholder="XX:XX" value="18:00" :readonly="!canEdit()&&!canContinue()" :onblur="transformTimeEnd()">
              </p>
              <label class="label">Количество попыток дозвониться</label>
              <span class="select">
                <select v-model="campaign.postponingAttempts" :disabled="!canEdit()">
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </span>
              <label class="label">Интервал между потворными звонками (минуты)</label>
              <span class="select">
                <select v-model="campaign.postponingIntervalMin" :disabled="!canEdit()">
                  <option>30</option>
                  <option>60</option>
                  <option>120</option>
                  <option>240</option>
                </select>
              </span>
              <label class="label">Сценарий</label>
              <p class="control">
              <span class="select">
                <select v-model="campaign.scenario" :disabled="!canEdit()" v-on:click="getScenarioReadyState">
                  <option v-for="scenario in scenarios" v-bind:value="scenario.id">
                    {{scenario.name}}
                  </option>
                </select>
              </span>
                <button v-if="campaign.scenario" class="button is-info" v-on:click="gotoScenario">
                <span class="icon">
                  <i class="fa fa-edit"></i>
                </span>
                  <span>Открыть сценарий</span>
                </button>
                <button v-if="isReadyScenario" class="button is-success is-outlined" :disabled="true">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>Сценарий подготовлен</span>
                </button>
                <button v-else class="button is-danger is-outlined" :disabled="true">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>Сценарий не подготовлен</span>
                </button>
              </p>
              <label class="label">База</label>
              <div class="control">
                <input class="button is-info" :disabled="!canEdit()" type="button" id="uploadFile" value="Загрузить из файла" @click="uploadFile('uploadPhones')">
                <input style="display:none;" @input="uploadPhones('uploadPhones')" :id="`uploadPhones`" name="load-phones" type="file" accept=".txt,.csv,.xls,.xlsx">
                <button  :disabled="!canEdit()" class="button is-info" v-on:click="openModalClipboard">
                  <span class="icon">
                    <i class="fa fa-clipboard"></i>
                  </span>
                  <span>Загрузить из буфера обмена</span>
                </button>
                <button v-if="tasksCount>0" class="button is-info" v-on:click="viewCallTasks">
                <span class="icon">
                  <i class="fa fa-list-alt"></i>
                </span>
                  <span>Просмотреть базу</span>
                </button>
                <button v-if="tasksCountPerformed==0 && tasksCount>0 && !campaign.archiveStatus" :disabled="!canEdit()" class="button is-light delete-button" v-on:click="openModalDelete">
                <span class="icon">
                  <i class="fa fa-minus-circle"></i>
                </span>
                  <span>Удалить базу</span>
                </button>
                <button v-if="canContinue()" class="button is-warning" v-on:click="getReadyCallTasksCSV">
                  <span class="icon">
                    <i class="fa fa-info"></i>
                  </span>
                  <span>Необработанные номера</span>
                </button>
              </div>
              <p>Загружено номеров: {{tasksCount}}</p>
              <label class="label">Тестовый звонок</label>
              <div class="control is-grouped">
              <p class="control">
                <button :disabled="campaign.archiveStatus" class="button is-primary" v-on:click="callTest(true)">
                  <span class="icon">
                    <i class="fa fa-volume-control-phone"></i>
                  </span>
                  <span>Позвонить на номер</span>
                </button>
              </p>
              <p class="control is-expanded">
                <input :disabled="campaign.archiveStatus" v-model="testPhone" class="input" type="text" placeholder="Введите номер">
              </p>
              <p class="control is-expanded">
                <button class="button is-info" v-on:click="viewTestCallTasks">
                  <span class="icon">
                    <i class="fa fa-list-alt"></i>
                  </span>
                  <span>Просмотреть результаты тестов</span>
                </button>
              </p>
              </div>
              <div v-if="!campaign.archiveStatus" class="control">
                <collapse accordion>
                  <collapse-item title="Параметры тестового звонка">
                    <div class="table-responsive">
                      <table class="table is-bordered is-striped is-narrow">
                        <thead>
                        <tr>
                          <th>Ключ</th>
                          <th>Значение</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(param, index) in testPhoneParametersArray">
                          <td>
                            <input v-model="param[0]" class="input" type="text">
                          </td>
                          <td>
                            <input v-model="param[1]" class="input" type="text">
                          </td>
                          <td>
                            <button class="button is-light" v-on:click="deleteTestPhoneParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                              <span>Удалить</span>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td><button class="button is-light" v-on:click="addTestPhoneParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                            <span>Добавить</span>
                          </button></td>
                          <td></td>
                          <td></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </collapse-item>
                </collapse>
              </div>
              <br>

            </tab-pane>
            <tab-pane v-if="canAccessAdditionalParameters(permissionKey)" label="Дополнительные параметры">
              <label v-if="loggedRole == 1" class="label">FS Gateway</label>
              <p  v-if="loggedRole == 1" class="control">
              <span class="select">
                <select v-model="campaign.gateway" :disabled="!canEdit()">
                  <option v-for="fsGateway in fsGateways" v-bind:value="fsGateway.name">
                    {{fsGateway.name}}
                  </option>
                </select>
              </span>
              </p>
              <label class="label">Приоритет</label>
              <p class="control">
                <input v-model="campaign.priority" class="input" type="text" placeholder="Приоритет рассылки" :readonly="!canEdit()">
              </p>
              <label class="label">Record Host</label>
              <p class="control">
                <input v-model="campaign.recordHost" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Postponing Strategy</label>
              <p class="control">
                <input v-model="campaign.postponingStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Schedule Strategy</label>
              <p class="control">
                <input v-model="campaign.scheduleStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Tel Error Strategy</label>
              <p class="control">
                <input v-model="campaign.telErrorStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Dialplan Context</label>
              <p class="control">
                <input v-model="campaign.dialplanContext" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Dialplan Extension</label>
              <p class="control">
                <input v-model="campaign.dialplanExtension" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Target Strategy</label>
              <p class="control">
                <input v-model="campaign.targetStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <label class="label">Phone Preprocessing Strategy</label>
              <p class="control">
                <input v-model="campaign.phonePreprocessingStrategy" class="input" type="text" :readonly="!canEdit()">
              </p>
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th>Ключ</th>
                    <th>Значение</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(param, index) in phonePreprocessingParametersArray">
                    <td>
                      <input v-model="param[0]" class="input" type="text" :readonly="!canEdit()">
                    </td>
                    <td>
                      <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                    </td>
                    <td>
                      <button :disabled="!canEdit()" class="button is-light" v-on:click="deletePhonePreprocessingParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                        <span>Удалить</span>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td><button :disabled="!canEdit()" class="button is-light" v-on:click="addPhonePreprocessingParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                      <span>Добавить</span>
                    </button></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
          </tabs>
          <p class="control">
            <button  v-if="canEdit()||canContinue()" class="button is-primary" v-on:click="save(true)">
                <span class="icon">
                  <i class="fa fa-floppy-o"></i>
                </span>
              <span>Сохранить</span>
            </button>
            <button v-if="canSetReadyStatus() && !campaign.archiveStatus" :disabled="!canEdit()" class="button is-info" v-on:click="openModalReady" v-bind:disabled="appconfig.disableCampaignSetReadyState">
                <span class="icon">
                  <i class="fa fa-check-circle"></i>
                </span>
              <span>Подвтердить готовность</span>
            </button>
            <!--<button v-if="campaign.state=='Завершена' && !campaign.reportCreated" class="button is-info" v-on:click="prepareReport">
                    <span class="icon">
                      <i class="fa fa-calculator"></i>
                    </span>
              <span>Подготовить отчет</span>
            </button>-->
            <button v-if="campaign.state=='Завершена'" class="button is-info" v-on:click="getReportCSV">
                      <span class="icon">
                        <i class="fa fa-download"></i>
                      </span>
              <span>Загрузить отчет CSV</span>
            </button>
            <button class="button is-light" v-on:click="cancel">
                <span class="icon">
                  <i class="fa fa-times-circle"></i>
                </span>
              <span>Закрыть</span>
            </button>
            <button v-if="!campaign.archiveStatus" class="button is-info" v-on:click="viewMonitor">
                <span class="icon">
                  <i class="fa fa-tv"></i>
                </span>
              <span>Мониторинг рассылки</span>
            </button>
          </p>
          <div v-if="loggedUser==campaign.client" class="control is-grouped">
            <p class="control">
              <button class="button is-primary" v-on:click="makePayment">
                <span class="icon">
                  <i class="fa fa-money"></i>
                </span>
                <span>Оплатить рассылку на сумму</span>
              </button>
            </p>
            <p class="control is-expanded">
              <input v-model="sumPayment" class="input" type="" placeholder="Введите сумму оплаты" :readonly="!canEdit()">
            </p>
          </div>
        </article>
        <modal :visible="showModal" :title=title :confirmation=confirmation :clipboard=!confirmation @confirm="confirmAction" @close="closeModal"></modal>
      </div>
    </div>

</template>

<script>
import Datepicker from 'vue-bulma-datepicker'
import Cleave from 'vue-cleave'
import Modal from './Modal'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import { Tabs, TabPane } from 'vue-bulma-tabs'
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
import Message from 'vue-bulma-message'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const MessageComponent = Vue.extend(Message)
const openMessage = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 10000,
  container: '.messages'
}) => {
  return new MessageComponent({
    el: document.createElement('div'),
    propsData
  })
}

const CAMPAIGNS_API = '/api/campaigns'
const SCENARIOS_API = '/api/scenarios'
const PHONEBASEUPLOADING_API = '/outgoing-cpg'
const CALLTASKS_API = '/outgoing-cpg'
const PAYMENTS_API = '/api/payments'
const APPCONFIG_API = '/api/appConfig'
const FSGATEWAY_API = 'api/fsgateways'
const PROFILES_API = '/api/profiles'
const CALLTASKTESTING_API = '/outgoing-cpg/callTasksTesting'
const REPORTS_API = '/calls'

export default {
  props: ['id', 'idcopy'],
  components: {
    Datepicker,
    Cleave,
    Modal,
    Notification,
    Message,
    Tabs,
    TabPane,
    Collapse,
    CollapseItem
  },
  computed: {
    ...mapGetters([
      'loggedUser',
      'loggedId',
      'loggedRole',
      'clientId',
      'authenticationToken'
    ]),
    l10n () {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      }
    }
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    prepareSecurityHeaderYandex(uuid) {
      return {
        'Content-Type': 'application/json',
        'Idempotence-Key': uuid
      }
    },
    transformTimeStart () {
      this.campaign.timeStart = this.transform(this.campaign.timeStart)
    },
    transformTimeEnd () {
      this.campaign.timeEnd = this.transform(this.campaign.timeEnd)
    },
    transform (tt) {
      let t = tt
      if (t != null) {
        if (t.length === 3) {
          let part1 = t.substr(0, 2)
          let part2 = t.substr(2)
          if (part2 !== ':') {
            t = part1 + ':' + part2
          }
        }
        if (t.length > 5) {
          t = t.substr(0, 5)
        }
      } else {
        t = '12:00'
      }
      return t
    },
    save (showMessage) {
      if (this.checkTime()) {
        this.campaign.phonePreprocessingParameters = {}
        for (let i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          let item = this.phonePreprocessingParametersArray[i]
          this.campaign.phonePreprocessingParameters[item[0]] = item[1]
        }
        if (this.campaign.id === undefined) {
          this.saveNew(showMessage)
        } else {
          this.update(showMessage)
        }
      } else {
        this.openNotificationWithType('warning', 'Неверно указано время рассылки.')
      }
    },
    saveNew (showMessage) {
      console.log('saving new campaign: ' + JSON.stringify(this.campaign))
      this.$http.post(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() })
      .then((response) => {
        console.log(response.data)
        this.isSaved = true
        this.campaign = response.data
        if (showMessage) {
          this.openNotificationWithType('info', 'Рассылка сохранена.')
        }
//        this.$router.push('/campaigns/')
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ')
      })
    },
    update (showMessage) {
      console.log('updating campaign: ' + JSON.stringify(this.campaign))
      this.$http.put(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() })
      .then((response) => {
        console.log(response.data)
        this.isSaved = true
        if (showMessage) {
          this.openNotificationWithType('info', 'Рассылка сохранена.')
        }
//        this.$router.push('/campaigns/')
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ')
      })
    },
    uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить рассылку')
      } else {
        document.getElementById(buttonId).click()
      }
    },
    loadState () {
      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.isActive = response.data
        if (!this.isActive && !this.campaign.archiveStatus) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          })
        }
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ')
      })
    },
    loadAppConfig () {
      this.$http.get(APPCONFIG_API + '/' + this.clientId, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.appconfig = response.data
          this.campaign.gateway = this.appconfig.defaultGateway
          this.campaign.scheduleStrategy = this.appconfig.defaultScheduleStrategy
          this.campaign.postponingStrategy = this.appconfig.defaultPostponingConfig.strategy
          this.campaign.telErrorStrategy = this.appconfig.defaultTelErrorStrategy.strategy
          this.campaign.postponingAttempts = this.appconfig.defaultPostponingConfig.parameters.attempts
          this.campaign.postponingIntervalMin = this.appconfig.defaultPostponingConfig.parameters.waitMinutes
          this.campaign.dialplanContext = this.appconfig.defaultDialplanContext
          this.campaign.dialplanExtension = this.appconfig.defaultDialplanExtension
          this.campaign.targetStrategy = this.appconfig.defaultTargetStrategy
          this.campaign.phonePreprocessingStrategy = this.appconfig.defaultPhonePreprocessingStrategy.strategy
          this.campaign.recordHost = this.appconfig.defaultRecordHost
          this.phonePreprocessingParametersArray = Object.entries(this.appconfig.defaultPhonePreprocessingStrategy.parameters)
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
        })
    },
    loadCampaign () {
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('opening campaign ' + response.data.id)
        this.campaign = response.data
        this.phonePreprocessingParametersArray = Object.entries(this.campaign.phonePreprocessingParameters)
        this.loadTasksCount()
        this.loadTasksCountPerformed()
        this.isSaved = true
        this.getScenarioReadyState()
        this.loadState()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки рассылки. ')
      })
    },
    deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1)
    },
    addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({})
    },
    deleteTestPhoneParameter(index) {
      this.testPhoneParametersArray.splice(index, 1)
    },
    addTestPhoneParameter() {
      this.testPhoneParametersArray.push({})
    },
    copyCampaign () {
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.idcopy,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('copying campaign ' + response.data.id)
        this.campaign = response.data
        this.campaign.id = undefined
        this.notSaved()
        this.loadState()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка создания копии рассылки. ')
      })
    },
    loadScenarios () {
      this.$http.get(SCENARIOS_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
        this.scenarios = response.data
    })
    .catch((error) => {
        console.log(error)
      this.openNotificationWithType('danger', 'Ошибка загрузки сценариев. ')
    })
    },
    loadFsGateways () {
      this.$http.get(FSGATEWAY_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.fsGateways = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadTasksCount () {
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/count', {headers: this.prepareSecurityHeader()})
        .then((response) => {
        this.tasksCount = response.data
    })
    .catch((error) => {
        console.log(error)
    })
    },
    loadTasksCountPerformed () {
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/countPerformed', {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.tasksCountPerformed = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getScenarioReadyState() {
      this.$http({
        url: SCENARIOS_API + '/isReady/' + this.campaign.scenario,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.isReadyScenario = response.data
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка получения состояния сценария. ')
      })
    },
    openModalDelete () {
      console.log('Нажали удалить базу')
      this.title = 'Удалить базу?'
      this.confirmation = true
      this.openModal()
    },
    openModalReady () {
      this.title = 'Подтверждаете готовность рассылки?'
      this.confirmation = true
      this.openModal()
    },
    openModalClipboard () {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку')
      } else {
        this.title = 'Загрузка базы'
        this.confirmation = false
        this.openModal()
      }
    },
    closeModal () {
      this.showModal = false
    },
    openModal () {
      this.showModal = true
    },
    confirmAction (value) {
      this.closeModal()
      if (this.title == 'Подтверждаете готовность рассылки?') {
        this.save(false)
        this.setReadyStatus()
      }
      if (this.title == 'Удалить базу?') {
        this.deletePhones()
      }
      if (this.title == 'Загрузка базы') {
        this.clipboard = value
        this.uploadPhonesFromClipboard()
      }
    },
    uploadPhonesFromClipboard() {
      this.handleUploadPhonesFromClipboardRequest()
    },
    handleUploadPhonesFromClipboardRequest () {
      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaignFromClipboard', this.prepareClipboardMultipartFile(this.clipboard, this.campaign.id),
        {headers: this.prepareSecurityHeader(), timeout: 180000})
        .then(response => {
          if (response.status == 200) {
            if (response.data == '') {
              this.openNotificationWithType('info', 'База загружена.')
              this.loadTasksCount()
            } else {
              this.openNotificationWithType('danger', response.data, 0)
              this.loadTasksCount()
            }
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            this.loadTasksCount()
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', 'Ошибка загрузки файла')
          this.loadTasksCount()
          console.log(error)
        })
      this.loadTasksCountPerformed()
    },
    prepareClipboardMultipartFile (phonesClipboard, phonesCampaign) {
      const phonesFormData = new FormData()
      phonesFormData.append('clipboard', phonesClipboard)
      phonesFormData.append('campaign', phonesCampaign)
      return phonesFormData
    },
    uploadPhones(inputId) {
      const input = document.querySelector(`#${inputId}`)
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку')
        } else {
//          this.save(false)
          this.handleUploadPhonesRequest(input.files[0])
        }
      }
    },
    handleUploadPhonesRequest (phonesFile) {
      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, this.campaign.id),
        {headers: this.prepareSecurityHeader(), timeout: 180000})
        .then(response => {
          if (response.status == 200) {
            if (response.data == '') {
              this.openNotificationWithType('info', 'База загружена.')
              this.loadTasksCount()
            } else {
              this.openNotificationWithType('danger', response.data, 0)
              this.loadTasksCount()
            }
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            this.loadTasksCount()
          }
      })
    .catch(error => {
      this.openNotificationWithType('danger', 'Ошибка загрузки файла')
        this.loadTasksCount()
        console.log(error)
    })
      this.loadTasksCountPerformed()
    },
    prepareMultipartFile (phonesFile, phonesCampaign) {
      const phonesFormData = new FormData()
      phonesFormData.append('file', phonesFile)
      phonesFormData.append('campaign', phonesCampaign)
      return phonesFormData
    },
    deletePhones() {
      this.$http.delete(`${PHONEBASEUPLOADING_API}/${this.campaign.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'База удалена.')
          this.tasksCount = 0
//          this.save(false)
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка удаления телефонной базы. ')
        })
    },
    cancel () {
      if (this.campaign.archiveStatus) {
        this.$router.push('/archive/')
      } else {
        this.$router.push('/campaigns/')
      }
    },
    gotoScenario () {
      this.$router.push('/scenarios/' + this.campaign.id + '/' + this.campaign.scenario)
    },
    viewCallTasks () {
      this.$router.push('/callTasks/' + this.campaign.id)
    },
    viewMonitor () {
      this.$router.push('/monitoring/' + this.campaign.id)
    },
    viewTestCallTasks () {
      this.$router.push('/callTasksTest/' + this.campaign.id)
    },
    prepareReport () {
      this.$http.get('/report/prepareReportByCampaignId?campaignId=' + this.campaign.id)
        .then((response) => {
          this.openNotificationWithType('info', 'Отчет подготовлен')
          this.loadCampaign()
          this.loadScenarios()
          this.loadFsGateways()
        })
        .catch((error) => {
          this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
            ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
          console.log(error)
        })
    },
    getReportCSV () {
      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + this.campaign.id)
      this.$http.get(`${REPORTS_API}/id/${this.campaign.id}/win/csv?audioPath=${this.campaign.recordHost + '/' + this.campaign.clientId + '/' + this.campaign.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          var s = response.headers['content-disposition']
          var res = s.split('filename="').pop()
          res = res.split('"')[0]
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          // a.download = 'ReportByCampaign_' + this.campaign.name + '.csv'
          a.download = res
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
          console.log(error)
        })
    },
    getReadyCallTasksCSV () {
      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + this.campaign.id)
        .then((response) => {
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = 'readyCallTasksByCampaign_' + this.campaign.name + '.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
          console.log(error)
        })
    },
    makePayment() {
        if (this.reg.test(this.sumPayment)) {
          if (this.sumPayment > 0) {
            this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment),
              {headers: this.prepareSecurityHeader()})
              .then((response) => {
                window.location.href = response.data
              })
              .catch((error) => {
                console.log(error)
                this.openNotificationWithType('danger', 'Ошибка платежа. ')
              })
          } else {
            this.openNotificationWithType('danger', 'Укажите сумму больше нуля')
          }
        } else {
          this.openNotificationWithType('danger', 'Некорректный формат числа')
        }
    },
    preparePaymentParameters (id, sum) {
      const paymentFormData = new FormData()
      const currentUrl = window.location
      paymentFormData.append('id', id)
      paymentFormData.append('sum', sum)
      paymentFormData.append('returnUrl', currentUrl)
      return paymentFormData
    },
    setReadyStatus () {
      this.campaign.state = 'Подготовлена'
      this.$http.put(CAMPAIGNS_API, this.campaign, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('success', 'Рассылка подготовлена')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка запуска рассылки. ')
        })
    },
    canSetReadyStatus() {
      let result = ((this.campaign.state == 'В разработке' || this.canContinue()) &&
        this.canModerate(this.permissionKey) && this.campaign.client != null &&
        this.campaign.date != null && this.campaign.scenario != null && this.campaign.zoneOffset != null &&
        this.campaign.timeStart != null && this.campaign.timeEnd && this.isReadyScenario &&
        ((this.campaign.postponingIntervalMin == 0 && this.campaign.postponingAttempts == 0) ||
          (this.campaign.postponingIntervalMin != 0 && this.campaign.postponingAttempts != 0))) ||
        this.appconfig.campaignSetReadyButtonVisibleForAll
      return result
    },
    notSaved () {
      this.isSaved = false
    },
    canEdit() {
      if (this.campaign.archiveStatus) {
        return false
      }
      if (!this.isActive) {
        return false
      } else {
        if (this.loggedRole == 1) {
          return (this.campaign.state == 'В разработке') || (this.campaign.state == 'Подготовлена') || (this.campaign.id == undefined)
        } else {
          return (this.campaign.state == 'В разработке') || (this.campaign.id == undefined)
        }
      }
    },
    canContinue() {
      if (!this.isActive) {
        return false
      } else {
        return this.campaign.state == 'Завершена' && this.campaign.hasReadyTasks
      }
    },
    callTest (showMessage) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед тестом необходимо сохранить рассылку')
      } else {
        if (this.testPhone.trim() != '') {
          console.log('saving new testing call task: ' + JSON.stringify(this.testPhone))
          this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.campaign.id, this.testPhone, this.testPhoneParametersArray), {headers: this.prepareSecurityHeader()})
            .then((response) => {
              this.testPhone = ''
              this.testPhoneParametersArray = [
                {
                  key: '',
                  value: ''
                }
              ]
              // this.callTask = response.data
              this.loadTasksCount()
              if (showMessage) {
                this.openNotificationWithType('info', 'Номер тестового звонка сохранен.')
              }
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка создания тестового звонка. ')
          })
        }
      }
    },
    prepareTestPhoneForm (campaignId, testPhone, testPhoneParametersArray) {
      const formData = new FormData()
      formData.append('campaignId', campaignId)
      formData.append('phone', testPhone)
      let testPhoneParameters = {}
      for (let i = 0; i < testPhoneParametersArray.length; i++) {
        let item = testPhoneParametersArray[i]
        testPhoneParameters[item[0]] = item[1]
      }
      formData.append('parameters', JSON.stringify(testPhoneParameters))
      return formData
    },
    prepareTestPhone (campaignId, testPhone, testPhoneParametersArray) {
      let testCallTaskDto = {
        phone : '',
        campaign : '',
        parameters : {}
      }
      testCallTaskDto.campaign = campaignId
      testCallTaskDto.phone = testPhone
      let testPhoneParameters = {}
      for (let i = 0; i < testPhoneParametersArray.length; i++) {
        let item = testPhoneParametersArray[i]
        testPhoneParameters[item[0]] = item[1]
      }
      testCallTaskDto.parameters = testPhoneParameters
      return testCallTaskDto
    },
    checkTime() {
      return (this.regTime.test(this.campaign.timeStart) && this.regTime.test(this.campaign.timeEnd)) && (this.campaign.timeEnd.localeCompare(this.campaign.timeStart) > 0)
    },
    openNotificationWithType (type, message, duration) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type,
        duration: duration
      })
    }
  },
  data () {
    return {
      campaign: {
        timeStart: '10:00',
        timeEnd: '18:00'
      },
      scenarios: [],
      tasksCount: '',
      tasksCountPerformed: 0,
      sumPayment: 0,
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regTime: /^(([0,1][0-9])|(2[0-3])):[0-5][0-9]$/,
      showModal: null,
      title: '',
      confirmation: true,
      isSaved: false,
      fsGateways: [],
      appconfig: {},
      isActive: false,
      isReadyScenario: false,
      clipboard: '',
      testPhone: '',
      testPhoneParametersArray: [
        {
          key: '',
          value: ''
        }
      ],
      permissionKey: 'campaign',
      phonePreprocessingParametersArray: [
        {
          key: '',
          value: ''
        }
      ]
    }
  },
  created: function () {
    this.checkToken()
    this.loadAppConfig()
    this.loadFsGateways()
    if (!this.$props.id) {
      if (!this.$props.idcopy) {
        console.log('creating new campaign')
        this.notSaved()
        this.loadState()
      } else {
        console.log('copying campaign: ' + this.name)
        this.copyCampaign()
      }
    } else {
      console.log('loading campaign: ' + this.name)
      this.loadCampaign()
    }
    this.loadScenarios()
  }
}

</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.time {
  margin: 0px 5px 0px 5px;
  width: 60px;
}

.tabs {
  margin: 20px;
  .tab-content {
    min-height: 50px;
  }
}

p.phonepreprocessingparams {
  margin: -3px 10px 0px 10px;
}


</style>



// WEBPACK FOOTER //
// Campaign.vue?e7cf35d0